module.exports = __webpack_public_path__ + "static/media/18b-01-HOME_movil.eb43591c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18b/18b-01-HOME_movil.jpg
// module id = 226
// module chunks = 0